module.exports = __webpack_public_path__ + "fonts/iconfont.2187f964.woff2";